module.exports = __webpack_public_path__ + "img/19_4.e0fabd68.png";